module.exports = __webpack_public_path__ + "img/tv4.84423990.gif";